import { Button } from '@/components/form/Button';
import { ButtonVariant } from '@/components/form/buttonHelper';
import { Loading } from '@/components/loading/Loading';
import { Modal } from '@/components/modal/Modal';
import { ModalProps } from '@/components/modal/useModal';
import { Card } from '@/components/sections/Card';
import { useBundle } from '@/services/bundles/useBundleService';

import { FunctionComponent, Suspense, useState } from 'react';

const DeleteBundleModal: FunctionComponent<ModalProps<{ bundleId: string }>> = props => {
  const DeleteBundle = () => {
    const bundleId = props.props?.bundleId;
    if (!bundleId) throw new Error('Missing bundle id');

    const [bundles, deleteBundle] = useBundle(state => [state.bundles, state.deleteBundle]);

    const bundle = bundles.find(item => item.id === bundleId);

    if (!bundle) throw new Error('Missing bundle');

    const [loading, setLoading] = useState(false);

    const onDelete = async () => {
      setLoading(true);
      await deleteBundle(bundleId);
      setLoading(false);
      props.close();
    };

    return (
      <Card className="w-full p-8 space-y-2">
        <Modal.Controls {...props}>
          <h1 className="text-2xl font-bold">Delete Bundle</h1>
        </Modal.Controls>

        <div className="space-y-6">
          <p>
            Are you sure you want to delete: <span className="font-semibold">{bundle.name}?</span>
          </p>

          <div className="flex gap-2 justify-between">
            <Button onClick={props.close}>Cancel</Button>
            <Button type="button" variant={ButtonVariant.Destructive} loading={loading} onClick={onDelete}>
              Delete
            </Button>
          </div>
        </div>
      </Card>
    );
  };

  return (
    <Modal className="md:max-w-xl" {...props}>
      <Suspense fallback={<Loading />}>
        <DeleteBundle />
      </Suspense>
    </Modal>
  );
};

export default DeleteBundleModal;
